module.exports = __webpack_public_path__ + "static/img/7.bc38f58.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/eng/7.png
// module id = e87v
// module chunks = 0